// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay-ddjj {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-container-ddjj {
  background-color: white;
  border: 5px solid #dc3545;
  border-radius: 8px;
  max-width: 800px;
  width: 90%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal-header-ddjj {
  background-color: white;
  padding: 20px;
  text-align: center;
  border-bottom: 2px solid #dc3545;
}

.modal-header-ddjj h2 {
  margin: 0;
  font-weight: bold;
  font-size: 24px;
  color: #333;
}

.modal-body-ddjj {
  padding: 30px 40px;
  text-align: justify;
}

.modal-body-ddjj p {
  margin-bottom: 15px;
  line-height: 1.6;
  font-size: 14px;
  color: #333;
}

.emphasis-text {
  font-style: italic;
}

.qr-text {
  font-weight: bold;
}

.modal-footer-ddjj {
  padding: 20px;
  display: flex;
  justify-content: center;
  gap: 20px;
  border-top: 2px solid #dc3545;
}

.btn-acepto {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 12px 40px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-acepto:hover {
  background-color: #218838;
}

.btn-no-acepto {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 12px 40px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-no-acepto:hover {
  background-color: #c82333;
}
`, "",{"version":3,"sources":["webpack://./src/components/DeclaracionJurada/styles.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".modal-overlay-ddjj {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n}\n\n.modal-container-ddjj {\n  background-color: white;\n  border: 5px solid #dc3545;\n  border-radius: 8px;\n  max-width: 800px;\n  width: 90%;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.modal-header-ddjj {\n  background-color: white;\n  padding: 20px;\n  text-align: center;\n  border-bottom: 2px solid #dc3545;\n}\n\n.modal-header-ddjj h2 {\n  margin: 0;\n  font-weight: bold;\n  font-size: 24px;\n  color: #333;\n}\n\n.modal-body-ddjj {\n  padding: 30px 40px;\n  text-align: justify;\n}\n\n.modal-body-ddjj p {\n  margin-bottom: 15px;\n  line-height: 1.6;\n  font-size: 14px;\n  color: #333;\n}\n\n.emphasis-text {\n  font-style: italic;\n}\n\n.qr-text {\n  font-weight: bold;\n}\n\n.modal-footer-ddjj {\n  padding: 20px;\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  border-top: 2px solid #dc3545;\n}\n\n.btn-acepto {\n  background-color: #28a745;\n  color: white;\n  border: none;\n  padding: 12px 40px;\n  font-size: 16px;\n  font-weight: bold;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.btn-acepto:hover {\n  background-color: #218838;\n}\n\n.btn-no-acepto {\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  padding: 12px 40px;\n  font-size: 16px;\n  font-weight: bold;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.btn-no-acepto:hover {\n  background-color: #c82333;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
